// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ContentfulImage/ContentfulImage.css */

.contentful-image-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.contentful-image {
  display: block;
  max-width: 100%;
  height: auto;
  transition: opacity 0.3s ease;
}

.contentful-image.loading {
  opacity: 0;
}

.contentful-image.loaded {
  opacity: 1;
}

.contentful-image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-2);
}

.contentful-image-skeleton {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, var(--surface-2) 25%, var(--surface-3) 50%, var(--surface-2) 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Responsive image styles */
.contentful-image-container img {
  width: 100%;
  height: auto;
}

/* Aspect ratio preservation */
.contentful-image-container.aspect-square {
  aspect-ratio: 1 / 1;
}

.contentful-image-container.aspect-4-3 {
  aspect-ratio: 4 / 3;
}

.contentful-image-container.aspect-16-9 {
  aspect-ratio: 16 / 9;
}

.contentful-image-container.aspect-3-2 {
  aspect-ratio: 3 / 2;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentfulImage/ContentfulImage.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oGAAoG;EACpG,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* src/components/ContentfulImage/ContentfulImage.css */\n\n.contentful-image-container {\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n}\n\n.contentful-image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  transition: opacity 0.3s ease;\n}\n\n.contentful-image.loading {\n  opacity: 0;\n}\n\n.contentful-image.loaded {\n  opacity: 1;\n}\n\n.contentful-image-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--surface-2);\n}\n\n.contentful-image-skeleton {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, var(--surface-2) 25%, var(--surface-3) 50%, var(--surface-2) 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Responsive image styles */\n.contentful-image-container img {\n  width: 100%;\n  height: auto;\n}\n\n/* Aspect ratio preservation */\n.contentful-image-container.aspect-square {\n  aspect-ratio: 1 / 1;\n}\n\n.contentful-image-container.aspect-4-3 {\n  aspect-ratio: 4 / 3;\n}\n\n.contentful-image-container.aspect-16-9 {\n  aspect-ratio: 16 / 9;\n}\n\n.contentful-image-container.aspect-3-2 {\n  aspect-ratio: 3 / 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
